<template>
    <div class="category-panel-item">
        <div class="image" :style="{backgroundImage: imageOrPlaceholder(category.image)}"></div>
        <div class="content">
            <g-typography tag="h4" font-weight="semibold" :value="category.name" />
            <g-icon name="chevron-right" />
        </div>
    </div>
</template>

<script>
    import ActivationBriefProductConfigMixin from '../../mixins/ActivationBriefProductConfigMixin';
    export default {
        name:  'CategoryPanelItem',
        props: {
            category: {
                type:    Object,
                default: () => ({}),
            },
        },
        mixins: [ActivationBriefProductConfigMixin],
    };
</script>

<style lang="scss" scoped>

$image_size: 100px;

.category-panel-item {
    width: 100%;
    height: $image_size;
    display: flex;
    margin-bottom: 30px;
    .image {
        width: $image_size;
        height: 100%;
        background-size: cover;
    }
    .content {
        flex: 1;
        display: flex;
        justify-content: space-between;
        align-items: center;
        background-color: $g-color-grey-2;
        padding: 0 $g-spacing-4;
    }
}
</style>
